// Per-user module permission utility.
// Mirrors the backend Controllers/UserPermissions.vb — keep semantics in sync:
//  - Feature gated by the enableUserPermissions company preference; off = full access.
//  - Only 'User'-level accounts can be restricted (Admin/Owner = full access).
//  - permissions null/undefined = full access; explicit map: missing key = deny.

// Keys are exactly the App.js sidebar menu ids.
export const MODULE_KEYS = [
  { id: 'print-cheque', label: 'Print Cheques', description: 'Create, print and manage cheques' },
  { id: 'bulk-cheques', label: 'Bulk Cheques', description: 'Bulk cheque creation and printing' },
  { id: 'pdc-calendar', label: 'PDC Calendar', description: 'Post-dated cheque calendar' },
  { id: 'cheque-collection', label: 'Cheque Collection', description: 'Cheque delivery and collection tracking' },
  { id: 'reports', label: 'Reports', description: 'Cheque reports and exports' },
  { id: 'beneficiary-setup', label: 'Beneficiary Setup', description: 'Manage beneficiary master data' },
  { id: 'bank-setup', label: 'Bank Setup', description: 'Manage bank accounts and cheque templates' },
];

export const MODULE_IDS = MODULE_KEYS.map((m) => m.id);

/**
 * Decide access for one module.
 * @param {{enabled: boolean, role: string, permissions: Object|null}} permState from GET /users/me/permissions
 * @param {string} moduleId one of MODULE_IDS
 */
export const canAccessModule = (permState, moduleId) => {
  if (!permState || !permState.enabled) return true; // feature off = today's behavior
  const role = (permState.role || '').toLowerCase();
  if (role !== 'user') return true; // Admin/Owner/blank = full access
  if (!permState.permissions) return true; // null map = full access
  return permState.permissions[moduleId] === true; // explicit allow-list
};

/**
 * True when every module is ticked — the UI stores that as null (full access),
 * so fully-trusted users automatically get future modules.
 */
export const isFullAccessSelection = (selection) =>
  MODULE_IDS.every((id) => selection[id] === true);

export default { MODULE_KEYS, MODULE_IDS, canAccessModule, isFullAccessSelection };
